import { render, staticRenderFns } from "./MasterDetailForm.vue?vue&type=template&id=477dbfce&scoped=true&"
import script from "./MasterDetailForm.vue?vue&type=script&lang=ts&"
export * from "./MasterDetailForm.vue?vue&type=script&lang=ts&"
import style0 from "./MasterDetailForm.vue?vue&type=style&index=0&id=477dbfce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477dbfce",
  null
  
)

export default component.exports